import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { PrintService } from 'src/app/core/services/print.service';
import { Client } from 'src/app/shared/models/clients/client';
import { Opponent } from 'src/app/shared/models/data/opponent';
import { ExpertSession } from 'src/app/shared/models/hearings/expertSession';
import { User, UserRole } from 'src/app/shared/models/users/user';

@Component({
  selector: 'app-print-expert-session',
  templateUrl: './print-expert-session.component.html',
  styleUrls: ['./print-expert-session.component.scss']
})
export class PrintExpertSessionComponent implements OnInit {
  session: ExpertSession;
  clients: Client[];
  opponents: Opponent[];
  fileNum: string;
  lawyersStr: string[];
  lawyersArStr: string[];
  user: User;
  userRole = UserRole;


  constructor(
    private printService: PrintService,
    private auth: AuthService,
  ) {
    this.user = this.auth.user;
    this.getServiceData();
  }

  ngOnInit(): void {
    this.printService.onDataReady('Expert Session');
  }

  getServiceData() {
    this.session = this.printService.data.session;
    this.clients = this.printService.data.fileInfo.clients;
    this.opponents = this.printService.data.fileInfo.opponents;
    this.fileNum = this.printService.data.fileInfo.fileNum;
    this.lawyersStr = this.printService.data.fileInfo.lawyersStr;
    this.lawyersArStr = this.printService.data.fileInfo.lawyersArStr;
  }

}
